import React, {useEffect, useState} from 'react';
import TrackingTable, {OrderBaseItem} from "./components/TrackingTablePage";
import {TrackingTableTitle} from "../../../enums/DeliveryTrackingTableEnum";
import { useDeliveryTaskOrderList } from '../store/deliveryStore';
import {t} from "../../../i18n";

interface TransferOutProps {
}

const TransferOutPage: React.FC<TransferOutProps> = () => {
    const [transferOutData,setTransferOutData] = useState<OrderBaseItem[]>([]);
    const {deliveryTaskOrderList: deliveringTasks} = useDeliveryTaskOrderList();
    useEffect(() => {
        if (!deliveringTasks.length) return;
        const transferOutsData = deliveringTasks.filter(item => item.isTransferOut
            && !item.isAbnormal
            && !item?.orderWithAddress?.order?.isFinished) || [];
        if (!transferOutsData.length) return;
        const formattedData = transferOutsData.map(item => ({
            trackingNumber: item.trackingNumber,
            value: item.transferToDriverName || '-',
        }));
        setTransferOutData(formattedData);
    }, [deliveringTasks])

    return (
        <TrackingTable
            title={TrackingTableTitle.TRANSFER_OUT}
            data={transferOutData}
            tableRows={[t('pages.delivery.detail.trackingNumber'), t('pages.delivery.task.transferOut.transferTo')]}
        />
    );
};

export default TransferOutPage;
